import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	WellBeingScaleDto,
	WellBeingScaleRequest,
	WellBeingScaleSaveDto,
} from '../DTO/forms-management/wellBeingScale';

export const wellBeingScale = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getWellBeingScaleList: builder.query<
			SuccessResponse<WellBeingScaleDto[]>,
			string
		>({
			query: (id) => ({
				url: `/web/form/well-being-scale/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['WellBeingScaleList'],
		}),
		deleteWellBeingScale: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/well-being-scale/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['WellBeingScaleList'],
		}),
		wellBeingScaleHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/well-being-scale/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getWellBeingScaleDraft: builder.query<
			SuccessResponse<WellBeingScaleSaveDto>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/well-being-scale/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueWellBeingScaleDraft: builder.mutation<
			SuccessResponse<WellBeingScaleSaveDto>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/well-being-scale/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editWellBeingScale: builder.mutation<
			SuccessResponse<any>,
			WellBeingScaleRequest
		>({
			query: (body) => ({
				url: `/web/form/well-being-scale/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createWellBeingScale: builder.mutation<
			SuccessResponse<any>,
			WellBeingScaleRequest
		>({
			query: (body) => ({
				url: `/web/form/well-being-scale`,
				method: 'POST',
				body,
			}),
		}),
		getWellBeingScaleDetail: builder.query<
			SuccessResponse<WellBeingScaleDto>,
			string
		>({
			query: (id) => ({
				url: `/web/form/well-being-scale/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetWellBeingScaleListQuery,
	useDeleteWellBeingScaleMutation,
	useWellBeingScaleHasDraftQuery,
	useGetWellBeingScaleDraftQuery,
	useContinueWellBeingScaleDraftMutation,
	useEditWellBeingScaleMutation,
	useCreateWellBeingScaleMutation,
	useGetWellBeingScaleDetailQuery,
} = wellBeingScale;
